import { render } from "./edit.vue?vue&type=template&id=2ce98981"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=2ce98981&lang=scss"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/widget/shop/carousel/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ce98981"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ce98981', __exports__)) {
    console.log('reload')
    api.reload('2ce98981', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=2ce98981", () => {
    console.log('re-render')
    api.rerender('2ce98981', render)
  })

}


export default __exports__